{
  "save": "Speichern",
  "cancel": "Abbrechen",
  "submit": "Senden",
  "loading": "Lädt...",
  "ok": "OK",
  "add": "Neu",
  "continue": "Weiter",
  "select": "Auswählen...",
  "selectedCount": "{{count}} ausgewählt",
  "notAvailable": "–",
  "close": "Close",
  "compressingImage": "Compressing image...",
  "hide": "Hide",
  "show": "Show",
  "applying": "Applying...",
  "back": "Back",
  "delete": "Delete",
  "duplicate": "Duplicate",
  "lock": "Lock",
  "mixed": "Mixed",
  "multipleValues": "Multiple values",
  "next": "Next",
  "or": "or",
  "remove": "Remove",
  "unlock": "Unlock",
  "units": {
    "meters": "Meter",
    "feet": "Fuß"
  },
  "sandbox": {
    "title": "{{name}}s Sandbox",
    "badge": "Sandbox",
    "section": "Ihre Sandbox",
    "description": "Ein privater Bereich zum Lernen und Experimentieren"
  }
}
